import React from "react";
import { Button, Container } from "react-bootstrap";
import "./HeroSection.css";
import { Link } from "react-router-dom";

function HeroSection() {
  return (
    <section className="heroSection">
      <div className="hero-overlay">
        <Container className="text-center hero-content">
          <h1 className="hero-title">Escape to Tranquility at Jaltaara Resort</h1>
          <p className="hero-desc">
            Nestled amidst the lush hills of New Mahabaleshwar, Jaltaara Resort 
            offers a serene retreat where nature meets luxury. Unwind in 
            our cozy rooms, savor breathtaking views, and experience 
            unmatched hospitality in the heart of Tetali, Jawali.
          </p>

          <div className="hero-btn-group">
            <Link to={"/contact-us"}>
              <Button variant="outline-light" className="discover-btn">
                Contact Us
              </Button>
            </Link>
          </div>
        </Container>
      </div>


      <div className="vdo_banner_holder">
            <div className="vdo_holder">
              <video className="resort_vdo"  muted playsInline autoPlay loop>
                <source
                  src="/assets/images/gallery/jaltaaraa_vdo.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
    </section>
  );
}

export default HeroSection;
